export default "__VITE_ASSET__O6wJ8R8X__"